import {
  INetZeroDetailFormValues,
  ITermTargetFormValues,
} from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import dayjs, { Dayjs } from 'dayjs';

export const booleanOptions = [
  { label: 'มี', value: 'true' },
  { label: 'ไม่มี', value: 'false' },
];

export const setDateMonthToFirst = (date: Dayjs | undefined) => {
  if (!date) return undefined;
  return dayjs(date).set('date', 1).set('month', 0);
};

export const setNumber = (data: number | string | undefined) => {
  if (!data) return undefined;
  return Number(data);
};

export const setBoolean = (data: boolean | 'true' | 'false'): boolean => {
  if (data === 'true') return true;
  if (data === 'false') return false;
  return Boolean(data);
};

export const createNewNetZeroDetail = (data: INetZeroDetailFormValues) => {
  const { baseYear, nearTermTarget, longTermTarget } = data;

  return {
    id: data.id ?? undefined,
    scopeId: data.scopeId,
    baseYear: {
      year: setDateMonthToFirst(baseYear.year),
      gasEmissionQuantity: setNumber(baseYear.gasEmissionQuantity),
    },
    nearTermTarget: {
      year: setDateMonthToFirst(nearTermTarget?.year),
      gasEmissionPercent: setNumber(nearTermTarget?.gasEmissionPercent),
      gasEmissionQuantity: setNumber(nearTermTarget?.gasEmissionQuantity),
    },
    longTermTarget: {
      year: setDateMonthToFirst(longTermTarget?.year),
      gasEmissionPercent: setNumber(longTermTarget?.gasEmissionPercent),
      gasEmissionQuantity: setNumber(longTermTarget?.gasEmissionQuantity),
    },
    isTgo: setBoolean(data.isTgo),
    tgoId: data.tgoId === '' ? undefined : data.tgoId,
    isSbti: setBoolean(data.isSbti),
    sbtiId: data.sbtiId === '' ? undefined : data.sbtiId,
  };
};

export const checkTermTargetComplete = (
  data: ITermTargetFormValues | undefined
): boolean => {
  if (!data) return false;

  const { year, gasEmissionPercent, gasEmissionQuantity } = data;
  const hasYear = Boolean(year);
  const hasTarget = Boolean(gasEmissionPercent) || Boolean(gasEmissionQuantity);

  return hasYear && hasTarget;
};

export const mapNetZeroFormValues = (data: INetZeroDetailFormValues) => {
  return {
    ...data,
    tgoId: data.tgoId ?? '',
    sbtiId: data.sbtiId ?? '',
  };
};
